module.exports = __webpack_public_path__ + "static/media/step6-back.1df294d5.png";